import { render, staticRenderFns } from "./EventsListItem.vue?vue&type=template&id=6f068d6a&scoped=true&"
import script from "./EventsListItem.vue?vue&type=script&lang=ts&"
export * from "./EventsListItem.vue?vue&type=script&lang=ts&"
import style0 from "./EventsListItem.vue?vue&type=style&index=0&id=6f068d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f068d6a",
  null
  
)

export default component.exports